export default "__VITE_ASSET__CNm6mLH5__"